// Route wrapper to show different workflow views based on user role

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/sdk/auth/hooks';
import { helpers } from '@/client/utils/helpers';
import { WorkflowsPage } from '@/modules/workflows/pages/WorkflowsPage';

export function WorkflowsRouteWrapper() {
  const { user, currentOrg, featurePermissions, userPermission } = useAuth();
  const isSuperAdmin = user?.is_super_admin ?? false;

  const canViewTemplates = isSuperAdmin || helpers.hasFeature(featurePermissions, userPermission, isSuperAdmin, 'workflows');

  if (!canViewTemplates) {
    return <Navigate to={`/dashboard/${currentOrg?.id}/workflows/instant`} replace />;
  }

  return <WorkflowsPage />;
}
